import { render, staticRenderFns } from "./budgets.vue?vue&type=template&id=b15e510c"
import script from "./budgets.ts?vue&type=script&lang=js&external"
export * from "./budgets.ts?vue&type=script&lang=js&external"
import style0 from "./budgets.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports